import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { bindFlyer, catchBasket } from './fly-into-basket'
import type { Flight } from './fly-into-basket'

export function BasketFlight() {
  const [flight, setFlight] = useState<Flight | null>(null)
  const photo = useRef<HTMLImageElement>(null)

  useEffect(() => {
    bindFlyer(setFlight, () => setFlight(null))
    return () => bindFlyer(null, null)
  }, [])

  useEffect(() => {
    const el = photo.current
    if (flight === null || el === null) return
    const { start, end } = flight
    const dx = end.left + end.width / 2 - (start.left + start.width / 2)
    const dy = end.top + end.height / 2 - (start.top + start.height / 2)
    const scale = Math.min(end.width / start.width, end.height / start.height)
    const lift = Math.min(72, Math.abs(dy) * 0.18)
    const run = el.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1, borderRadius: '1.75rem' },
        {
          transform: `translate(${dx * 0.55}px, ${dy * 0.4 - lift}px) scale(${Math.max(scale * 1.15, 0.4)})`,
          opacity: 1,
          borderRadius: '2rem',
          offset: 0.45
        },
        {
          transform: `translate(${dx}px, ${dy}px) scale(${scale})`,
          opacity: 0.15,
          borderRadius: '999px'
        }
      ],
      { duration: 560, easing: 'cubic-bezier(0.22, 0.75, 0.2, 1)', fill: 'forwards' }
    )
    run.onfinish = () => {
      setFlight(null)
      catchBasket()
    }
    return () => run.cancel()
  }, [flight])

  if (flight === null) return null
  return createPortal(
    <img
      ref={photo}
      src={flight.src}
      alt=""
      aria-hidden="true"
      className="pointer-events-none fixed z-[60] object-contain shadow-[var(--shadow-tile)]"
      style={{
        left: flight.start.left,
        top: flight.start.top,
        width: flight.start.width,
        height: flight.start.height,
        transformOrigin: 'center center'
      }}
    />,
    document.body
  )
}
